"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withdrawTemplatesError = exports.withdrawTemplateError = exports.subscribeToWithdrawalTickets = exports.submittingWithdraw = exports.requestWithdrawTickets = exports.receiveWithdrawWorkflowInfo = exports.receiveWithdrawTickets = exports.receiveWithdrawTicket = exports.receiveWithdrawTemplates = exports.receiveWithdrawTemplate = exports.receiveWithdrawFee = exports.getWithdrawTickets = exports.getWithdrawFee = exports.getAccountVerificationLevelConfig = exports.fetchingWithdrawTemplates = exports.fetchingWithdrawTemplate = exports.fetchProductWithdrawTemplates = exports.fetchProductWithdrawTemplate = exports.createWithdrawTicket = exports.cancelWithdrawTicket = exports.addWithdrawalTicket = exports.SUBMITTING_WITHDRAW = exports.RETAIL_FIAT_CONFIRM_WITHDRAW = exports.REQUEST_WITHDRAW_TICKETS = exports.RECEIVE_WITHDRAW_WORKFLOW_INFO = exports.RECEIVE_WITHDRAW_TICKETS = exports.RECEIVE_WITHDRAW_TICKET = exports.RECEIVE_WITHDRAW_TEMPLATE_ERROR = exports.RECEIVE_WITHDRAW_TEMPLATES_ERROR = exports.RECEIVE_WITHDRAW_TEMPLATES = exports.RECEIVE_WITHDRAW_TEMPLATE = exports.RECEIVE_WITHDRAW_FEE = exports.RECEIVE_VERIFICATION_LEVEL_CONFIGS = exports.FETCH_PRODUCT_WITHDRAW_TEMPLATES = exports.FETCH_PRODUCT_WITHDRAW_TEMPLATE = exports.ADD_WITHDRAWAL_TICKET = void 0;
var _apiActions = require("./apiActions");
var _withdrawSubscriptionService = _interopRequireDefault(require("../../services/subscriptions/withdrawSubscriptionService"));
var _snackbarActions = require("./snackbarActions");
var _sidePaneActions = require("./sidePaneActions");
var _errorTextFormatter = require("../../helpers/errorTextFormatter");
var _excluded = ["ProductId", "amount", "iconFileName", "ProductSymbol", "ProductFullName", "AccountProviderId"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var REQUEST_WITHDRAW_TICKETS = exports.REQUEST_WITHDRAW_TICKETS = 'REQUEST_WITHDRAW_TICKETS';
var FETCH_PRODUCT_WITHDRAW_TEMPLATES = exports.FETCH_PRODUCT_WITHDRAW_TEMPLATES = 'FETCH_PRODUCT_WITHDRAW_TEMPLATES';
var FETCH_PRODUCT_WITHDRAW_TEMPLATE = exports.FETCH_PRODUCT_WITHDRAW_TEMPLATE = 'FETCH_PRODUCT_WITHDRAW_TEMPLATE';
var RECEIVE_WITHDRAW_TEMPLATES = exports.RECEIVE_WITHDRAW_TEMPLATES = 'RECEIVE_WITHDRAW_TEMPLATES';
var RECEIVE_WITHDRAW_TEMPLATE = exports.RECEIVE_WITHDRAW_TEMPLATE = 'RECEIVE_WITHDRAW_TEMPLATE';
var RECEIVE_WITHDRAW_TEMPLATES_ERROR = exports.RECEIVE_WITHDRAW_TEMPLATES_ERROR = 'RECEIVE_WITHDRAW_TEMPLATE_ERROR';
var RECEIVE_WITHDRAW_TEMPLATE_ERROR = exports.RECEIVE_WITHDRAW_TEMPLATE_ERROR = 'RECEIVE_WITHDRAW_TEMPLATE_ERROR';
var SUBMITTING_WITHDRAW = exports.SUBMITTING_WITHDRAW = 'SUBMITTING_WITHDRAW';
var RECEIVE_WITHDRAW_TICKET = exports.RECEIVE_WITHDRAW_TICKET = 'RECEIVE_WITHDRAW_TICKET';
var RECEIVE_WITHDRAW_TICKETS = exports.RECEIVE_WITHDRAW_TICKETS = 'RECEIVE_WITHDRAW_TICKETS';
var RECEIVE_WITHDRAW_WORKFLOW_INFO = exports.RECEIVE_WITHDRAW_WORKFLOW_INFO = 'RECEIVE_WITHDRAW_WORKFLOW_INFO';
var RECEIVE_WITHDRAW_FEE = exports.RECEIVE_WITHDRAW_FEE = 'RECEIVE_WITHDRAW_FEE';
var RETAIL_FIAT_CONFIRM_WITHDRAW = exports.RETAIL_FIAT_CONFIRM_WITHDRAW = 'RETAIL_FIAT_CONFIRM_DEPOSIT';
var ADD_WITHDRAWAL_TICKET = exports.ADD_WITHDRAWAL_TICKET = 'ADD_WITHDRAWAL_TICKET';
var fetchProductWithdrawTemplates = exports.fetchProductWithdrawTemplates = function fetchProductWithdrawTemplates(productId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch, getState) {
      var payload, data, _data, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            dispatch(fetchingWithdrawTemplates);
            payload = {
              ProductId: productId,
              OMSId: getState().user.userInfo.OMSId,
              AccountId: getState().user.selectedAccountId
            };
            _context.p = 1;
            _context.n = 2;
            return dispatch((0, _apiActions.callAPI)('GetWithdrawFormTemplateTypes', payload));
          case 2:
            data = _context.v;
            if (!data.result) {
              _context.n = 4;
              break;
            }
            if (data.TemplateTypes.length) {
              _context.n = 3;
              break;
            }
            return _context.a(2, dispatch(withdrawTemplatesError('There are no providers configured for this product')));
          case 3:
            dispatch(receiveWithdrawTemplates(data.TemplateTypes));
            if (data.TemplateTypes.length === 1) {
              dispatch(fetchProductWithdrawTemplate(productId, data.TemplateTypes[0].AccountProviderId));
            }
            return _context.a(2, true);
          case 4:
            return _context.a(2, dispatch(withdrawTemplatesError(data.errormsg)));
          case 5:
            _context.p = 5;
            _t = _context.v;
            _context.n = 6;
            return dispatch((0, _apiActions.callAPI)('GetWithdrawTemplateTypes', payload));
          case 6:
            _data = _context.v;
            if (_data.result) {
              dispatch(fetchProductWithdrawTemplate(productId, _data.TemplateTypes[0]));
            }
            dispatch(withdrawTemplatesError(_data.errormsg));
          case 7:
            return _context.a(2);
        }
      }, _callee, null, [[1, 5]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var fetchProductWithdrawTemplate = exports.fetchProductWithdrawTemplate = function fetchProductWithdrawTemplate(ProductId, AccountProviderId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dispatch, getState) {
      var TemplateType, template, payload, data;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            dispatch(fetchingWithdrawTemplate(ProductId, AccountProviderId));
            template = getState().withdraw.templateTypes.find(function (i) {
              return i.AccountProviderId === parseFloat(AccountProviderId);
            });
            if (template) {
              TemplateType = template.TemplateName;
            } else {
              TemplateType = getState().withdraw.template;
            }
            payload = _objectSpread({
              OMSId: getState().user.userInfo.OMSId,
              AccountId: getState().user.selectedAccountId,
              TemplateType: TemplateType,
              ProductId: ProductId,
              AccountProviderId: AccountProviderId
            }, options);
            _context2.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetWithdrawTemplate', payload));
          case 1:
            data = _context2.v;
            if (!(data.result && data.Template)) {
              _context2.n = 2;
              break;
            }
            return _context2.a(2, dispatch(receiveWithdrawTemplate(data)));
          case 2:
            return _context2.a(2, dispatch(withdrawTemplateError(data.errormsg)));
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var getTemplateFormPayloadByInfo = function getTemplateFormPayloadByInfo(infoRaw, template) {
  // New object based on template saved in state
  var result = Object.keys(template).reduce(function (acc, key) {
    if (infoRaw[key] !== undefined && infoRaw[key] !== null && infoRaw[key] !== '') {
      acc[key] = infoRaw[key];
    }
    return acc;
  }, {});
  return JSON.stringify(result);
};
var createWithdrawTicket = exports.createWithdrawTicket = function createWithdrawTicket(_ref3) {
  var ProductId = _ref3.ProductId,
    amount = _ref3.amount,
    iconFileName = _ref3.iconFileName,
    ProductSymbol = _ref3.ProductSymbol,
    ProductFullName = _ref3.ProductFullName,
    AccountProviderId = _ref3.AccountProviderId,
    info = _objectWithoutProperties(_ref3, _excluded);
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(dispatch, getState) {
      var OMSId, AccountId, templateForm, accountProviderId, templateTypeObj, template, kytDetails, travelRuleFields, travelRuleValues, payload, withdrawStatus, workflowDetail, _t2;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            dispatch(submittingWithdraw);
            OMSId = getState().user.userInfo.OMSId;
            AccountId = getState().user.selectedAccountId;
            templateForm = info.TemplateForm || info;
            accountProviderId = AccountProviderId || getState().withdraw.AccountProviderId;
            templateTypeObj = getState().withdraw.templateTypes.find(function (template) {
              return template.AccountProviderId === parseInt(accountProviderId);
            }); // Since undefined is not serializable we default every prop to an empty string to avoid missing fields
            Object.keys(templateForm).forEach(function (prop) {
              return templateForm[prop] = templateForm[prop] || '';
            });

            // Extract travel rule fields for top-level kytdetails
            template = getState().withdraw.template;
            kytDetails = null;
            if (template.TravelRuleFields) {
              travelRuleFields = JSON.parse(template.TravelRuleFields);
              travelRuleValues = {};
              travelRuleFields.forEach(function (fieldData) {
                if (templateForm[fieldData.Name] !== undefined && templateForm[fieldData.Name] !== null && templateForm[fieldData.Name] !== '') {
                  travelRuleValues[fieldData.Name] = templateForm[fieldData.Name];
                }
              });
              if (Object.keys(travelRuleValues).length > 0) {
                kytDetails = JSON.stringify(travelRuleValues);
              }
            }
            payload = {
              OMSId: OMSId,
              AccountId: AccountId,
              ProductId: +ProductId,
              Amount: info.Amount,
              TemplateForm: getTemplateFormPayloadByInfo(templateForm, template),
              TemplateType: templateTypeObj.TemplateName || getState().withdraw.template.TemplateType,
              AccountProviderId: +templateTypeObj.AccountProviderId
            }; // Add kytdetails as top-level field if we have travel rule data
            if (kytDetails) {
              payload.Kytdetails = kytDetails;
            }
            _context3.n = 1;
            return dispatch((0, _apiActions.callAPI)('CreateWithdrawTicket', payload));
          case 1:
            withdrawStatus = _context3.v;
            if (!(withdrawStatus.result === false)) {
              _context3.n = 2;
              break;
            }
            return _context3.a(2, dispatch((0, _snackbarActions.showSnack)({
              id: 'withdrawRejectSnack',
              text: (0, _errorTextFormatter.formatErrorText)(withdrawStatus),
              type: 'warning'
            })));
          case 2:
            _context3.p = 2;
            workflowDetail = JSON.parse(withdrawStatus.detail);
            if (!(_typeof(workflowDetail) === 'object' && workflowDetail.ReplyObject && workflowDetail.ReplyObject !== '0')) {
              _context3.n = 3;
              break;
            }
            return _context3.a(2, dispatch(receiveWithdrawWorkflowInfo(workflowDetail)));
          case 3:
            _context3.n = 5;
            break;
          case 4:
            _context3.p = 4;
            _t2 = _context3.v;
          case 5:
            dispatch((0, _sidePaneActions.closeWithdrawSidePane)());
            dispatch((0, _snackbarActions.showSnack)({
              id: 'withdrawSuccessSnack',
              // t("Your withdraw has been successfully added, please check email for instructions.")
              text: 'Your withdraw has been successfully added, please check email for instructions.',
              type: 'success'
            }));
            dispatch(receiveWithdrawTicket(withdrawStatus));
            return _context3.a(2, dispatch(getWithdrawTickets(AccountId, OMSId)));
        }
      }, _callee3, null, [[2, 4]]);
    }));
    return function (_x5, _x6) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var getWithdrawFee = exports.getWithdrawFee = function getWithdrawFee(ProductId, Amount, AccountProviderId) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(dispatch, getState) {
      var OMSId, AccountId, payload, withdrawFee, _t3;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            OMSId = getState().user.userInfo.OMSId;
            AccountId = getState().user.selectedAccountId;
            payload = {
              OMSId: OMSId,
              ProductId: ProductId,
              AccountId: AccountId,
              AccountProviderId: AccountProviderId,
              Amount: Amount
            };
            _context4.p = 1;
            if (payload.AccountProviderId) {
              payload.AccountProviderId = parseInt(payload.AccountProviderId);
            }
            _context4.n = 2;
            return dispatch((0, _apiActions.callAPI)('GetWithdrawFee', payload));
          case 2:
            withdrawFee = _context4.v;
            _context4.n = 4;
            break;
          case 3:
            _context4.p = 3;
            _t3 = _context4.v;
            console.error(_t3);
          case 4:
            if (!(withdrawFee && withdrawFee.result === false)) {
              _context4.n = 5;
              break;
            }
            return _context4.a(2, dispatch((0, _snackbarActions.showSnack)({
              id: 'withdrawRejectSnack',
              text: (0, _errorTextFormatter.formatErrorText)(withdrawFee),
              type: 'warning'
            })));
          case 5:
            dispatch(receiveWithdrawFee(withdrawFee));
          case 6:
            return _context4.a(2);
        }
      }, _callee4, null, [[1, 3]]);
    }));
    return function (_x7, _x8) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var cancelWithdrawTicket = exports.cancelWithdrawTicket = function cancelWithdrawTicket(_ref6) {
  var RequestCode = _ref6.RequestCode;
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(dispatch, getState) {
      var _getState$user$userIn, OMSId, UserId, AccountId, payload, withdrawStatus;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            _getState$user$userIn = getState().user.userInfo, OMSId = _getState$user$userIn.OMSId, UserId = _getState$user$userIn.UserId;
            AccountId = getState().user.selectedAccountId;
            payload = {
              OMSId: OMSId,
              UserId: UserId,
              AccountId: AccountId,
              RequestCode: RequestCode
            };
            _context5.n = 1;
            return dispatch((0, _apiActions.callAPI)('CancelWithdraw', payload));
          case 1:
            withdrawStatus = _context5.v;
            if (!(withdrawStatus.result === false)) {
              _context5.n = 2;
              break;
            }
            return _context5.a(2, dispatch((0, _snackbarActions.showSnack)({
              id: 'cancelWithdrawSnack',
              text: (0, _errorTextFormatter.formatErrorText)(withdrawStatus),
              type: 'warning'
            })));
          case 2:
            // t('Your withdraw has been successfully canceled')
            dispatch((0, _snackbarActions.showSnack)({
              id: 'cancelWithdrawSuccessSnack',
              text: 'Your withdraw has been successfully canceled',
              type: 'success'
            }));
            dispatch(getWithdrawTickets(AccountId, OMSId));
          case 3:
            return _context5.a(2);
        }
      }, _callee5);
    }));
    return function (_x9, _x0) {
      return _ref7.apply(this, arguments);
    };
  }();
};
var subscribeToWithdrawalTickets = exports.subscribeToWithdrawalTickets = function subscribeToWithdrawalTickets() {
  return function (dispatch) {
    _withdrawSubscriptionService["default"].subscribe(function (updates) {
      dispatch(addWithdrawalTicket(updates));
    });
  };
};
var addWithdrawalTicket = exports.addWithdrawalTicket = function addWithdrawalTicket(payload) {
  return {
    type: ADD_WITHDRAWAL_TICKET,
    payload: payload
  };
};
var fetchingWithdrawTemplates = exports.fetchingWithdrawTemplates = {
  type: FETCH_PRODUCT_WITHDRAW_TEMPLATES
};
var fetchingWithdrawTemplate = exports.fetchingWithdrawTemplate = function fetchingWithdrawTemplate(ProductId, AccountProviderId) {
  return {
    type: FETCH_PRODUCT_WITHDRAW_TEMPLATE,
    payload: {
      ProductId: ProductId,
      AccountProviderId: AccountProviderId
    }
  };
};
var receiveWithdrawTemplates = exports.receiveWithdrawTemplates = function receiveWithdrawTemplates(payload) {
  return {
    type: RECEIVE_WITHDRAW_TEMPLATES,
    payload: payload
  };
};
var receiveWithdrawTemplate = exports.receiveWithdrawTemplate = function receiveWithdrawTemplate(payload) {
  return {
    type: RECEIVE_WITHDRAW_TEMPLATE,
    payload: payload
  };
};
var withdrawTemplatesError = exports.withdrawTemplatesError = function withdrawTemplatesError(payload) {
  return {
    type: RECEIVE_WITHDRAW_TEMPLATES_ERROR,
    payload: payload
  };
};
var withdrawTemplateError = exports.withdrawTemplateError = function withdrawTemplateError(payload) {
  return {
    type: RECEIVE_WITHDRAW_TEMPLATE_ERROR,
    payload: payload
  };
};
var submittingWithdraw = exports.submittingWithdraw = {
  type: SUBMITTING_WITHDRAW
};
var receiveWithdrawTicket = exports.receiveWithdrawTicket = function receiveWithdrawTicket(payload) {
  return {
    type: RECEIVE_WITHDRAW_TICKET,
    payload: payload
  };
};
var receiveWithdrawFee = exports.receiveWithdrawFee = function receiveWithdrawFee(payload) {
  return {
    type: RECEIVE_WITHDRAW_FEE,
    payload: payload
  };
};
var requestWithdrawTickets = exports.requestWithdrawTickets = function requestWithdrawTickets(payload) {
  return {
    type: REQUEST_WITHDRAW_TICKETS,
    payload: payload
  };
};
var receiveWithdrawTickets = exports.receiveWithdrawTickets = function receiveWithdrawTickets(payload) {
  return {
    type: RECEIVE_WITHDRAW_TICKETS,
    payload: payload
  };
};
var receiveWithdrawWorkflowInfo = exports.receiveWithdrawWorkflowInfo = function receiveWithdrawWorkflowInfo(payload) {
  return {
    type: RECEIVE_WITHDRAW_WORKFLOW_INFO,
    payload: payload
  };
};
var getWithdrawTickets = exports.getWithdrawTickets = function getWithdrawTickets(AccountId, OMSId) {
  var StartIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(dispatch) {
      var withdrawTickets;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.n) {
          case 0:
            dispatch(requestWithdrawTickets({
              StartIndex: StartIndex
            }));
            _context6.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetWithdrawTickets', {
              AccountId: AccountId,
              OMSId: OMSId,
              StartIndex: StartIndex
            }));
          case 1:
            withdrawTickets = _context6.v;
            dispatch(receiveWithdrawTickets(withdrawTickets));
          case 2:
            return _context6.a(2);
        }
      }, _callee6);
    }));
    return function (_x1) {
      return _ref8.apply(this, arguments);
    };
  }();
};
var RECEIVE_VERIFICATION_LEVEL_CONFIGS = exports.RECEIVE_VERIFICATION_LEVEL_CONFIGS = 'RECEIVE_VERIFICATION_LEVEL_CONFIGS';
var receiveVerificationLevelConfigs = function receiveVerificationLevelConfigs(payload) {
  return {
    type: RECEIVE_VERIFICATION_LEVEL_CONFIGS,
    payload: payload
  };
};
var getAccountVerificationLevelConfig = exports.getAccountVerificationLevelConfig = function getAccountVerificationLevelConfig() {
  return /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(dispatch, getState) {
      var state;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.n) {
          case 0:
            state = getState();
            _context7.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetVerificationLevelConfig', {
              OMSId: state.user.userInfo.OMSId,
              AccountId: state.user.selectedAccountId
            })).then(function (res) {
              return dispatch(receiveVerificationLevelConfigs(res));
            });
          case 1:
            return _context7.a(2);
        }
      }, _callee7);
    }));
    return function (_x10, _x11) {
      return _ref9.apply(this, arguments);
    };
  }();
};